import { Checkbox } from '@/global/components/Checkbox'
import Menu from '@/global/components/Menu'
import { ReactNode } from 'react'
import { GridButton } from './MenuComponents'

interface Option {
    value: string
    label: string
}

interface Props {
    startIcon?: ReactNode
    label: string
    options: Option[]
    selected: Set<string>
    onChange: (selected: Set<string>) => void
}

export default function GridCheckboxMenuButton({
    startIcon,
    label,
    options,
    selected,
    onChange,
}: Props) {
    const toggle = (value: string) => {
        const next = new Set(selected)
        next.has(value) ? next.delete(value) : next.add(value)
        onChange(next)
    }

    return (
        <Menu.Root arrow>
            <Menu.Trigger>
                <GridButton
                    startIcon={startIcon as JSX.Element}
                    label={label}
                />
            </Menu.Trigger>
            <Menu.Popover className="flex flex-col gap-2 p-2">
                {options.map(option => (
                    <Checkbox
                        key={option.value}
                        label={option.label}
                        checked={selected.has(option.value)}
                        onCheckedChange={() => toggle(option.value)}
                    />
                ))}
            </Menu.Popover>
        </Menu.Root>
    )
}
